import React, { useState, useRef, useEffect } from "react"; // <--- Add useRef
import Styles from "./CreateRfpTender.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { saveAs } from "file-saver";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";

import Fileupload from "../../../commons/Inputs/FileUpload/Fileupload";
import FileDownloadIcon from "../../../assets/images/Download_brand.svg";
import DateInput from "../../../commons/Inputs/DateInputBailateral/DateInput";
import TimeInput from "../../../commons/Inputs/TimeInputBailateral/TimeInput";
import TextInput from "../../../commons/Inputs/TextInput/TextInput";

import { createListing, editListing } from "../../../Services/BuySell/Creation";
import {
  createAuctionTender,
  terminateTender,
  updateAuctionTender,
} from "../../../Services/ReverseAuction/AlterApi";
import { formatDateElement } from "../../../commons/FormatDate";
import {
  getAllGenerators,
  getOthersGenerators,
  getSelfGenerators,
} from "../../../Services/ReverseAuction/GetApi";
import { handleInviteParticipants } from "../../../Services/ReverseAuction/AlterApi";
import TenderTemplate from "../../../assets/docs/Tender.xlsx";
import RfqTemplate from "../../../assets/docs/RFP_RFQ_for_Custom.xlsx";
import RfqTemplateGridco from "../../../assets/docs/RFP_RFQ_for_odisha.xlsx";
import RfqTemplateTradeConnect from "../../../assets/docs/Tradeconnect_for_odisha.xlsx";
import { toast } from "react-toastify";
import { ErrorMessage } from "../../../commons/Toast/ErrorMessage";
import ConfirmationModal from "../../../commons/ConfirmationModal/ConfirmationModal";
import { toastProperties } from "../../../commons/Toast/Toaster";
import AuctionDateInput from "../../../commons/Inputs/Auction/AuctionDateInput/AuctionDateInput";
import AuctionTimeInput from "../../../commons/Inputs/Auction/AuctionTimeInput/AuctionTimeInput";
import CircularProgress from "@mui/material/CircularProgress";
import { auctionGet } from "../../../Redux/Slices/auctionSlice";
import { activeType2Loading } from "../../../Redux/Slices/notificationSlice";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import { getTraderMap } from "../../../Services/Admin/Alter";
import SelectInput from "../../../commons/Inputs/Select/SelectInput";
import { useLocation } from "react-router-dom";

const checkAreSame = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // This works because both will produce "Thu Nov 06 2025"
  return d1.toDateString() === d2.toDateString();
};

const convertEndTimeFormat = (timeString) => {
  return timeString === "24:00" ? "23:59" : timeString;
};

const CreateRfpTender = ({
  open,
  handleClose,
  editData,
  duplicate,
  priceDiscoveryType,
  type,
  onSuccess,
}) => {
  const companyId = useSelector(
    (state) => state?.persistedReducer?.user?.company?.companyId,
  );
  const isTrader = useSelector((state) => state?.persistedReducer);
  const state = useSelector(
    (store) => store?.persistedReducer?.company?.stateLabel,
  );
  const loacation = useLocation();
  const url = loacation?.pathname || "";
  const isTradeConnect = url === "/tradeconnect";
  const isRfq = url === "/rfq";
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();
  const uploadLock = useRef(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state?.persistedReducer?.userType);
  const [excelUpload, setExcelUpload] = useState({});
  const [excelResetKey, setExcelResetKey] = useState(0);
  const [error, setError] = useState({});
  const stateListMain = useSelector((state) => state?.persistedReducer?.user);
  const stateId = stateListMain?.consumers?.filter(
    (ele) => ele?.consumerId === stateListMain?.activeConsumerId,
  )[0]?.stateUtId;

  const mapingData = useSelector((s) => s?.platformSlice?.userPaymentConfigs);
  const paymentConfigurationId = mapingData?.filter((ele) =>
    isTradeConnect
      ? ele?.productName === "TRADE_CONNECT"
      : ele?.productName === "RFP_RFQ",
  )?.[0]?.configurations?.[0]?.configurationId;
  const paymentConfigurationIdBil = mapingData?.filter(
    (ele) => ele?.productName === "BILATERAL",
  )?.[0]?.configurations?.[0]?.configurationId;

  const reqList = editData?.requisitions || [
    {
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      quantity: "",
      minQty: "",
    },
  ];
  const tenderData = editData || {};

  const [requisitions, setRequisitions] = useState(
    type === "edit"
      ? reqList.map((item) => ({
          startDate: item.dateStartAt || "",
          endDate: item.dateEndAt || "",
          startTime: item.slotStartAt || "",
          endTime: item.slotEndAt || "",
          quantity: item.requiredQty || "",
          price: item.landingCost || "",
          minQty: item.minimumQty || "",
        }))
      : [
          {
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: "",
            quantity: "",
            price: "",
            minQty: "",
          },
        ],
  );
  const [tenderStartDate, setTenderStartDate] = useState(
    type === "edit" && tenderData?.tenderStartDate
      ? new Date(tenderData.tenderStartDate)
      : "",
  );
  const [tenderEndDate, setTenderEndDate] = useState(
    type === "edit" && tenderData?.tenderEndDate
      ? new Date(tenderData.tenderEndDate)
      : "",
  );
  const [tenderStartTime, setTenderStartTime] = useState(
    type === "edit" ? tenderData?.tenderStartTime : "",
  );
  const [tenderEndTime, setTenderEndTime] = useState(
    type === "edit" ? tenderData?.tenderEndTime : "",
  );
  const [biddingStartDate, setBiddingStartDate] = useState(
    type === "edit" && tenderData?.biddingStartDate
      ? new Date(tenderData.biddingStartDate)
      : "",
  );
  const [biddingEndDate, setBiddingEndDate] = useState(
    type === "edit" && tenderData?.biddingEndDate
      ? new Date(tenderData.biddingEndDate)
      : "",
  );
  const [biddingStartTime, setBiddingStartTime] = useState(
    type === "edit" ? tenderData?.biddingStartTime : "",
  );
  const [biddingEndTime, setBiddingEndTime] = useState(
    type === "edit" ? tenderData?.biddingEndTime : "",
  );

  const [initialMargin, setInitialMargin] = useState(
    type === "edit" ? tenderData?.initialMargin : 100,
  );
  const [Emd, setEmd] = useState(type === "edit" ? tenderData?.Emd : 0);

  const [paymentSecurity, setPaymentSecurity] = useState(
    type === "edit" ? tenderData?.paymentSecurity : 1,
  );
  const [comment, setComment] = useState(
    type === "edit" ? tenderData?.comments : "",
  );
  const [generalTC, setGeneralTC] = useState(
    type === "edit" ? tenderData?.generalTC : null,
  );

  const [tenderType, setTenderType] = useState(
    state === "OD"
      ? isTradeConnect
        ? "CLOSED"
        : "OPEN"
      : type === "edit"
        ? tenderData?.auctionType
        : "OPEN",
  );

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [confirmHeader, setConfirmHeader] = useState("");
  const [confirmAction, setConfirmAction] = useState(null);
  const [editClosed, setEditClosed] = useState([]);
  const [defData, setDefData] = useState([]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [acceptSystemTerms, setAcceptSystemTerms] = useState(false);
  const [hideForm, setHideForm] = useState(false);

  const trader = useSelector((state) => state?.persistedReducer);
  const userTraderType = useSelector(
    (state) => state?.persistedReducer?.user?.isUserEntity,
  );

  const stateLabel = trader?.company?.stateLabel;
  const traderParent = trader?.roles?.includes("TRADER") && userTraderType;
  const [traderUserList, setTraderUserList] = useState([]);
  const [entityName, setEntityName] = useState(
    type === "edit" ? tenderData?.tenderEntityName : "",
  );

  const isOdisha = trader?.user?.company?.stateLabel === "OD";

  useEffect(() => {
    handleTenderType(tenderType || "CLOSED");
  }, [tenderType]);

  useEffect(() => {
    if (userTraderType) {
      handleGetTraderList();
    }
  }, []);

  const handleGetTraderList = async () => {
    let res = await getTraderMap(companyId, user);
    if (res?.data?.code === 200) {
      setTraderUserList(res?.data?.data);
      if (type === "edit") {
        setEntityName(
          res?.data?.data?.filter(
            (ele) => ele?.entityName === editData?.tenderEntityName,
          )?.[0] || {},
        );
      }
    }
  };

  const handleTraderUserSelection = (val) => {
    setEntityName(val);
  };

  const handleTenderStartDate = (value) => setTenderStartDate(value);
  const handleTenderEndDate = (value) => setTenderEndDate(value);
  const handleTenderStartTime = (value) => setTenderStartTime(value);
  const handleTenderEndTime = (value) =>
    setTenderEndTime(value === "24:00" ? "23:59" : value);
  const handleBiddingStartDate = (value) => setBiddingStartDate(value);
  const handleBiddingEndDate = (value) => setBiddingEndDate(value);
  const handleBiddingStartTime = (value) => setBiddingStartTime(value);
  const handleBiddingEndTime = (value) =>
    setBiddingEndTime(value === "24:00" ? "23:59" : value);

  const handleComment = (value) => setComment(value);
  const handleGeneralTC = (value) => setGeneralTC(value?.id);
  const fileInputRef = useRef(null);

  async function handleDownloadExcel() {
    try {
      const date = new Date();

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      const dateString = `${day}-${month}-${year}`;

      const fileUrl =
        stateLabel === "OD" && isTradeConnect
          ? RfqTemplateTradeConnect
          : stateLabel === "OD" && isRfq
            ? RfqTemplateGridco
            : RfqTemplate;

      const fileName = `Rfq_${dateString}.xlsx`;

      const response = await fetch(fileUrl);
      const blob = await response.blob();

      saveAs(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        fileName,
      );
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  }

  const handleExcelUploadRFQ = (sheetData, fileName) => {
    // 1. PREVENT DOUBLE EXECUTION & EMPTY DATA
    if (uploadLock.current || !sheetData || sheetData.length === 0) return;

    uploadLock.current = true;
    setTimeout(() => {
      uploadLock.current = false;
    }, 1000);

    // ---------------------------------------------------------
    // 2. ROBUST HELPERS
    // ---------------------------------------------------------

    // Helper: Convert Excel Serial Date to JS Date
    const excelSerialDateToJSDate = (serial) => {
      if (!serial) return null;
      const msPerDay = 24 * 60 * 60 * 1000;
      const date = new Date(Math.round((serial - 25569) * msPerDay));
      return isNaN(date.getTime()) ? null : date;
    };

    // Helper: Parse Date (CRASH FIX IS HERE)
    const parseExcelDate = (val) => {
      if (!val) return null;

      let finalDate = null;

      // Case A: Already a Date object
      if (val instanceof Date) {
        finalDate = val;
      }
      // Case B: Excel Serial Number
      else if (typeof val === "number") {
        finalDate = excelSerialDateToJSDate(val);
      }
      // Case C: String Parsing
      else {
        const dateString = String(val).trim();

        // 1. Try "YYYY-MM-DD"
        if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [yyyy, mm, dd] = dateString.split("-");
          finalDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        }
        // 2. Try "DD-MM-YYYY" or "DD/MM/YYYY"
        else if (dateString.match(/^\d{1,2}[-/]\d{1,2}[-/]\d{4}$/)) {
          const parts = dateString.includes("-")
            ? dateString.split("-")
            : dateString.split("/");
          const [dd, mm, yyyy] = parts;
          finalDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        }
        // 3. Fallback to standard parser
        else {
          finalDate = new Date(dateString);
        }
      }

      // CRITICAL CHECK: If date is Invalid (NaN), return null to prevent Crash
      if (finalDate && isNaN(finalDate.getTime())) {
        console.warn("Invalid date encountered:", val);
        return null;
      }

      return finalDate;
    };

    // Helper: Parse Time
    const parseExcelTime = (val) => {
      if (val === undefined || val === null || val === "") return "";

      // Handle Excel Serial Time (0.5 = 12:00)
      if (typeof val === "number") {
        let totalSeconds = Math.round(val * 86400);
        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        const minutes = Math.floor(totalSeconds / 60);
        if (hours === 24) return "24:00";
        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      }

      // Handle Date Object
      if (val instanceof Date) {
        const timeStr = val.toTimeString().split(" ")[0]; // Gets HH:MM:SS
        return timeStr.substring(0, 5); // Extract only HH:MM
      }

      // Handle String
      if (typeof val === "string") {
        const str = val.trim();
        const match = str.match(/(\d{1,2}):(\d{2})/);
        if (match) {
          return `${match[1].padStart(2, "0")}:${match[2]}`;
        }
        return str;
      }
      return "";
    };

    const getVal = (row, key) =>
      row && row[key] !== undefined ? row[key] : "";

    // ---------------------------------------------------------
    // 3. KEY MAPPING
    // ---------------------------------------------------------
    const firstRow = sheetData[0];
    const thirdRow = sheetData[3];
    const keys = Object.keys(firstRow);

    const findKey = (searchStr) => {
      return keys.find((k) =>
        k
          .toLowerCase()
          .replace(/\s/g, "")
          .includes(searchStr.toLowerCase().replace(/\s/g, "")),
      );
    };

    // Find keys dynamically — template uses "Opening/Closing", fallback to "Start/End"
    const KEY_T_START_DATE =
      findKey("Opening Date") || findKey("Tender Start Date") || keys[1];
    const KEY_T_START_TIME =
      findKey("Opening Time") || findKey("Tender Start Time") || keys[2];
    const KEY_T_END_DATE =
      findKey("Closing Date") || findKey("Tender End Date") || keys[3];
    const KEY_T_END_TIME =
      findKey("Closing Time") || findKey("Tender End Time") || keys[4];
    const KEY_COL_A = keys[0];
    // Column B has no header in row 1, so XLSX assigns it "__EMPTY"
    const KEY_COL_B = keys.find((k) => k === "__EMPTY") || "__EMPTY";

    // ---------------------------------------------------------
    // 4. EXTRACT DATA
    // ---------------------------------------------------------
    const tenderRow = sheetData[0] || {};
    const biddingRow = sheetData[2] || {};
    const moneyRow = sheetData[4] || {};

    const commentRow = sheetData[sheetData?.length - 1] || {};

    // ---------------------------------------------------------
    // 4a. VALIDATE REQUIRED FIELDS & DATES
    // ---------------------------------------------------------
    const parsedTenderStartDate = parseExcelDate(
      getVal(tenderRow, KEY_T_START_DATE),
    );
    const parsedTenderStartTime = parseExcelTime(
      getVal(tenderRow, KEY_T_START_TIME),
    );
    const parsedTenderEndDate = parseExcelDate(
      getVal(tenderRow, KEY_T_END_DATE),
    );
    const parsedTenderEndTime = parseExcelTime(
      getVal(tenderRow, KEY_T_END_TIME),
    );
    const parsedBiddingStartDate = parseExcelDate(
      getVal(biddingRow, KEY_T_START_DATE),
    );
    const parsedBiddingStartTime = parseExcelTime(
      getVal(biddingRow, KEY_T_START_TIME),
    );
    const parsedBiddingEndDate = parseExcelDate(
      getVal(biddingRow, KEY_T_END_DATE),
    );
    const parsedBiddingEndTime = parseExcelTime(
      getVal(biddingRow, KEY_T_END_TIME),
    );
    const parsedEmd = getVal(moneyRow, KEY_T_START_TIME);
    const parsedInitialMargin = getVal(moneyRow, KEY_T_END_DATE);
    const parsedPaymentSecurity = getVal(moneyRow, KEY_T_END_TIME);
    // const parsedTenderType = String(getVal(moneyRow, KEY_T_START_DATE) || "")
    //   .trim()
    //   .toLowerCase();
    // --- Find Tender Type more robustly ---
    let parsedTenderType = "";

    // Search through rows to find "intrastate" or "interstate"
    for (let i = 0; i < sheetData.length; i++) {
      const row = sheetData[i] || {};
      const firstColValue = String(getVal(row, KEY_COL_A) || "")
        .trim()
        .toLowerCase();

      if (firstColValue === "intrastate" || firstColValue === "interstate") {
        parsedTenderType = firstColValue;
        console.log("Found tender type:", parsedTenderType, "at row index:", i);
        break;
      }
    }

    // If not found by search, try the original location
    if (!parsedTenderType) {
      const biddingDataRow = sheetData[3] || {};
      parsedTenderType = String(getVal(biddingDataRow, KEY_COL_A) || "")
        .trim()
        .toLowerCase();
      console.log("Fallback tender type extraction:", parsedTenderType);
    }
    let hasValidationErrors = false;

    // Debug: log all first column values
    console.log(
      "Sheet data first column values:",
      sheetData.map((row, idx) => ({
        index: idx,
        value: String(getVal(row, KEY_COL_A) || "").trim(),
      })),
    );
    // --- Validate tender type for OD state ---
    // if (state === "OD" && isRfq && parsedTenderType === "intrastate") {
    //   toast.error(
    //     "Intrastate type is not allowed for the current state. Please download the updated template.",
    //     toastProperties,
    //   );
    //   uploadLock.current = false;
    //   return;
    // }

    // Check missing required fields
    const missingFields = [];
    if (!parsedTenderStartDate) missingFields.push("Tender Start Date");
    if (!parsedTenderStartTime) missingFields.push("Tender Start Time");
    if (!parsedTenderEndDate) missingFields.push("Tender End Date");
    if (!parsedTenderEndTime) missingFields.push("Tender End Time");
    if (!parsedBiddingStartDate) missingFields.push("Bidding Start Date");
    if (!parsedBiddingStartTime) missingFields.push("Bidding Start Time");
    if (!parsedBiddingEndDate) missingFields.push("Bidding End Date");
    if (!parsedBiddingEndTime) missingFields.push("Bidding End Time");
    if (!parsedPaymentSecurity && parsedPaymentSecurity !== 0)
      missingFields.push("Payment Security");
    if (
      !parsedTenderType ||
      (parsedTenderType !== "intrastate" && parsedTenderType !== "interstate")
    )
      if (
        !parsedTenderType ||
        (parsedTenderType !== "intrastate" && parsedTenderType !== "interstate")
      ) {
        if (missingFields.length > 0) {
          toast.error("Invalid file format. Please use the latest template.");
          hasValidationErrors = true;
          uploadLock.current = false;
          return;
        }
      }
    if (missingFields.length > 0) {
      toast.error("Invalid file format. Please use the latest template.");
    }

    // --- Tender ---
    setTenderStartDate(parsedTenderStartDate);
    setTenderStartTime(parsedTenderStartTime);
    setTenderEndDate(parsedTenderEndDate);
    setTenderEndTime(
      parsedTenderEndTime === "24:00" ? "23:59" : parsedTenderEndTime,
    );

    // --- Tender Type (Intrastate = CLOSED, Interstate = OPEN) ---
    if (parsedTenderType === "intrastate") {
      setTenderType("CLOSED");
      // Fetch generators in background
      getSelfGenerators(stateId).then((res) => {
        if (res?.data?.code === 200) {
          setDefData(res?.data?.data?.map((ele) => ele.id) || []);
        }
      });
    } else if (parsedTenderType === "interstate") {
      setTenderType("OPEN");
      // Fetch generators in background
      getOthersGenerators(stateId).then((res) => {
        if (res?.data?.code === 200) {
          setDefData(res?.data?.data?.map((ele) => ele.id) || []);
        }
      });
    } else if (parsedTenderType) {
      // Log if extraction didn't match expected values
      console.warn("Extracted tender type not recognized:", parsedTenderType);
    }
    // --- Bidding ---
    setBiddingStartDate(parsedBiddingStartDate);
    setBiddingStartTime(parsedBiddingStartTime);
    setBiddingEndDate(parsedBiddingEndDate);
    setBiddingEndTime(
      parsedBiddingEndTime === "24:00" ? "23:59" : parsedBiddingEndTime,
    );

    // --- Money & Comments ---
    // Only update if the template actually contains these numeric fields; otherwise keep defaults
    if (typeof parsedEmd === "number") setEmd(parsedEmd);
    if (typeof parsedInitialMargin === "number")
      setInitialMargin(parsedInitialMargin * 100);
    if (typeof parsedPaymentSecurity === "number")
      setPaymentSecurity(parsedPaymentSecurity);
    setComment(getVal(commentRow, KEY_T_START_DATE) || "NA");

    // --- Requisitions ---
    const reqHeaderIndex = sheetData.findIndex((row) => {
      const val = getVal(row, KEY_COL_A);
      return val && String(val).toLowerCase().includes("requisition");
    });

    let resList = [];
    if (reqHeaderIndex !== -1) {
      const reqRows = sheetData.slice(reqHeaderIndex + 1);

      resList = reqRows
        .filter((row) => getVal(row, KEY_COL_A))
        .map((row) => ({
          startDate: parseExcelDate(getVal(row, KEY_COL_B)) || "",
          endDate: parseExcelDate(getVal(row, KEY_T_START_DATE)) || "",
          startTime: parseExcelTime(getVal(row, KEY_T_START_TIME)),
          endTime: parseExcelTime(getVal(row, KEY_T_END_DATE)),
          quantity: getVal(row, KEY_T_END_TIME) || "",
          minQty: getVal(row, keys[6] || "__EMPTY_1") || "",
        }));
    }

    setRequisitions(
      resList.filter((item) => item.startDate !== "" && item.quantity !== ""),
    );
    // Only show success if no validation errors occurred
    if (!hasValidationErrors) {
      toast.success(
        "Template uploaded successfully. All fields have been populated.",
      );
    }
    // Clear the state and reset the key to allow re-upload
    setExcelUpload({});
    setExcelResetKey((prev) => prev + 1); // This resets the file input
  };

  const handleValidateError = () => {
    const newErrors = {};
    const now = new Date();

    // 1. Time Rule Constants (in hours)
    const RULES = {
      TENDER_START_OFFSET: 2,
      TENDER_MIN_DURATION: 48,
      BID_START_AFTER_TENDER_START: 1,
      BID_MIN_DURATION: 2,
      RFQ_BID_BEFORE_TENDER_END: 4,
      NON_RFQ_BID_START_BEFORE_TENDER_END: 8,
      NON_RFQ_BID_END_BEFORE_TENDER_END: 6,
      RA_START_AFTER_BID_END: 2,
      RA_START_BEFORE_TENDER_END: 6,
      RA_MIN_DURATION: 2,
      RA_END_BEFORE_TENDER_END: 4,
      REQ_GAP_AFTER_TENDER_END: 48,
    };

    // 2. Helper to create Date objects
    const createDate = (date, time) => {
      if (!date || !time) return null;
      const newDate = new Date(date);
      const [hours, minutes] = time.split(":").map(Number);
      if (isNaN(newDate.getTime()) || isNaN(hours) || isNaN(minutes))
        return null;
      newDate.setHours(hours, minutes, 0, 0);
      return newDate;
    };

    // 3. Normalized Date Objects
    const tStart = createDate(tenderStartDate, tenderStartTime);
    const tEnd = createDate(tenderEndDate, tenderEndTime);
    const bStart = createDate(biddingStartDate, biddingStartTime);
    const bEnd = createDate(biddingEndDate, biddingEndTime);

    // --- REQUISITION VALIDATIONS ---
    requisitions.forEach((req, idx) => {
      if (!req.startDate)
        newErrors[`startDate_${idx}`] = "Start Date is required";
      if (!req.endDate) newErrors[`endDate_${idx}`] = "End Date is required";
      if (!req.startTime)
        newErrors[`startTime_${idx}`] = "Start Time is required";
      if (!req.endTime) newErrors[`endTime_${idx}`] = "End Time is required";
      if (!req.quantity)
        newErrors[`quantity_${idx}`] = "Req. Quantity is required";
      if (!req.minQty) newErrors[`minQty_${idx}`] = "Min. Quantity is required";

      const rStart = createDate(req.startDate, req.startTime);
      const rEnd = createDate(req.endDate, req.endTime);

      if (rStart && rEnd) {
        if (rEnd <= rStart)
          newErrors[`endTime_${idx}`] =
            "End Time must be greater than Start Time";
        // Requisition Common Rule: 48 hours after tender end
        if (
          tEnd &&
          rStart <
            new Date(tEnd.getTime() + RULES.REQ_GAP_AFTER_TENDER_END * 3600000)
        ) {
          newErrors[`startDate_${idx}`] =
            `Must be minimum ${RULES.REQ_GAP_AFTER_TENDER_END} hours after Tender End`;
        }
      }
    });

    // --- MANDATORY FIELDS ---
    if (!tenderStartDate)
      newErrors.tenderStartDate = "Tender Start Date is required";
    if (!tenderStartTime)
      newErrors.tenderStartTime = "Tender Start Time is required";
    if (!tenderEndDate) newErrors.tenderEndDate = "Tender End Date is required";
    if (!tenderEndTime) newErrors.tenderEndTime = "Tender End Time is required";
    if (!biddingStartDate)
      newErrors.biddingStartDate = "Bidding Start Date is required";
    if (!biddingStartTime)
      newErrors.biddingStartTime = "Bidding Start Time is required";
    if (!biddingEndDate)
      newErrors.biddingEndDate = "Bidding End Date is required";
    if (!biddingEndTime)
      newErrors.biddingEndTime = "Bidding End Time is required";

    // --- LOGIC RULES ---

    // Tender Start offset check
    if (tStart) {
      if (isOdisha) {
        if (tStart < new Date(now.getTime() + 2 * 3600000)) {
          newErrors.tenderStartTime = "Must be at least 2 hours from now";
        }
      } else {
        const msIn15Min = 15 * 60 * 1000;
        const nextSlot = new Date(
          Math.ceil(now.getTime() / msIn15Min) * msIn15Min,
        );
        if (tStart < nextSlot) {
          const hh = String(nextSlot.getHours()).padStart(2, "0");
          const mm = String(nextSlot.getMinutes()).padStart(2, "0");
          newErrors.tenderStartTime = `Must be at or after ${hh}:${mm}`;
        }
      }
    }

    // Odisha time gap rules
    if (isOdisha) {
      if (tStart && tEnd && tEnd < new Date(tStart.getTime() + 48 * 3600000)) {
        newErrors.tenderEndDate =
          "Must be minimum 48 hours after Tender Start";
      }
      if (bStart && tStart && bStart < new Date(tStart.getTime() + 1 * 3600000)) {
        newErrors.biddingStartDate = "Must be min 1 hour after Tender Start";
      }
      if (bEnd && bStart && bEnd < new Date(bStart.getTime() + 2 * 3600000)) {
        newErrors.biddingEndDate = "Must be min 2 hours after Bidding Start";
      }
      if (bEnd && tEnd && tEnd < new Date(bEnd.getTime() + 2 * 3600000)) {
        newErrors.biddingEndDate =
          "Bidding End must be at least 2 hours before Tender End";
      }
    }

    // Non-Odisha time gap rules
    if (!isOdisha) {
      if (tStart && tEnd && tEnd < new Date(tStart.getTime() + 2 * 3600000)) {
        newErrors.tenderEndDate =
          "Must be minimum 2 hours after Tender Start";
      }
      if (bEnd && bStart && bEnd < new Date(bStart.getTime() + 1 * 3600000)) {
        newErrors.biddingEndDate = "Must be min 1 hour after Bidding Start";
      }
      if (bEnd && tEnd && tEnd < new Date(bEnd.getTime() + 1 * 3600000)) {
        newErrors.biddingEndDate =
          "Bidding End must be at least 1 hour before Tender End";
      }
    }

    // Miscellaneous
    if (traderParent && !entityName?.entityName)
      newErrors.entityName = "Entity Name is required";
    if (!initialMargin) newErrors.initialMargin = "Initial Margin is required";
    if (!(Emd || Emd === 0)) newErrors.emd = "EMD is required";
    if (!paymentSecurity)
      newErrors.paymentSecurity = "Payment Security is required";

    // if (
    //   tenderType === "CLOSED" &&
    //   defData?.length + (editClosed?.length || 0) < 3
    // ) {
    //   toast.error(
    //     "Minimum 3 Generator required for the Closed Auction type",
    //     toastProperties,
    //   );
    //   newErrors.defData = "Minimum 3 Generator required";
    // }

    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRequirementChange = (index, field, value) => {
    setRequisitions(
      requisitions.map((req, i) =>
        i === index ? { ...req, [field]: value } : req,
      ),
    );
  };

  const handleAddRequirement = () => {
    setRequisitions([
      ...requisitions,
      {
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        quantity: "",
        minQty: "",
      },
    ]);
  };

  const handleRemoveRequirement = (index) => {
    if (requisitions?.length === 1) return;
    setRequisitions(requisitions.filter((_, i) => i !== index));
  };

  const handleTenderType = async (type) => {
    let res;
    if (type === "CLOSED") {
      res = await getSelfGenerators(stateId);
    }
    if (type === "OPEN") {
      res = await getOthersGenerators(stateId);
    }

    if (res?.data?.code === 200) {
      setDefData(res?.data?.data?.map((ele) => ele.id) || []);
    }

    setTenderType(type);
  };

  const handleFormSubmit = async () => {
    if (!tenderData?.id && !acceptSystemTerms)
      return ErrorMessage("Please accept System Terms and Conditions.");
    if (!handleValidateError()) return;
    setLoading(true);
    setIsSubmitting(true);
    dispatch(activeType2Loading(true));
    setTimeout(() => {
      setIsSubmitting(false);
    }, 2000);
    if (type === "edit" && !duplicate) {
      let updatePayload = {
        traderAssigned: isTrader?.roles?.includes("TRADER")
          ? isTrader?.user?.user?.userId
          : 0,
        id: tenderData?.capacityId,
        initialMargin: 100,
        emd: 0,
        paymentSecurity: 4,
        tenderDoc: generalTC,
        comments: comment,
        paymentConfigurationId:
          paymentConfigurationId || paymentConfigurationIdBil,
        slots: requisitions?.map((ele) => ({
          dateStartAt: formatDateElement(ele?.startDate),
          dateEndAt: formatDateElement(ele?.endDate),
          slotStartAt: ele?.startTime,
          slotEndAt: ele?.endTime === "24:00" ? "23:59" : ele?.endTime,
          requiredQty: Number(ele?.quantity),
          landingCost: Number(ele?.price),
          purchaseEnergy: Number(ele?.quantity),
          energyRateStr: "",
          minimumQty: Number(ele?.minQty),
        })),
      };
      let res = await editListing(
        updatePayload,
        user === "CONSUMER" ? "consumer" : "generator",
      );
      if (res?.data?.code === 200) {
        updateTender();
      }
      setLoading(false);
      dispatch(activeType2Loading(false));
      return;
    }
    let capacityPayload = {
      energySourceType: "Any",
      energyFuelType: "Any",
      traderAssigned: isTrader?.roles?.includes("TRADER")
        ? isTrader?.user?.user?.userId
        : 0,
      slots: requisitions?.map((ele) => ({
        dateStartAt: formatDateElement(ele?.startDate),
        dateEndAt: formatDateElement(ele?.endDate),
        slotStartAt: `${ele?.startTime?.split(":")?.[0]}:${
          ele?.startTime?.split(":")?.[1]
        }`,
        slotEndAt:
          ele?.endTime === "24:00" || ele?.endTime === "24:00:00"
            ? "23:59"
            : `${ele?.endTime?.split(":")?.[0]}:${
                ele?.endTime?.split(":")?.[1]
              }`,
        requiredQty: Number(ele?.quantity),
        landingCost: Number(ele?.price) || 1,
        purchaseEnergy: Number(ele?.quantity),
        energyRateStr: "",
        minimumQty: Number(ele?.minQty),
      })),
      isInterstate: true,
      lcVersionId: 3,
      isBilateral: false,
      priceDiscoveryType: priceDiscoveryType,
      matchingTags: "Solar,Noon,Hot",
      voltageLevel: "132kV",
      listingExpDate: formatDateElement(tenderEndDate),
      listingExpTime: `${tenderEndTime?.split(":")?.[0]}:${
        tenderEndTime?.split(":")?.[1]
      }`,
      paymentConfigurationId:
        paymentConfigurationId || paymentConfigurationIdBil,
      region: "Northern",
      initialMargin: 100,
      emd: 0,
      paymentSecurity: 4,
      termsExpDate: formatDateElement(tenderEndDate),
      termsExpTime: `${tenderEndTime?.split(":")?.[0]}:${
        tenderEndTime?.split(":")?.[1]
      }`,
      comment: comment,
      termsDocumentId: null,
      listingType: "GREATER_THAN_SEVEN_DAYS",
    };
    let res = await createListing(
      capacityPayload,
      user === "CONSUMER" ? "consumer" : "generator",
    );
    if (res?.data?.code === 200) {
      createTender(res?.data?.data?.id);
    }
    setLoading(false);
    dispatch(activeType2Loading(false));
  };

  const createTender = async (capId) => {
    let tenderPayload = {
      tenderEntityName: entityName?.entityName,
      traderAssigned: isTrader?.roles?.includes("TRADER")
        ? isTrader?.user?.user?.userId
        : 0,
      tenderType: priceDiscoveryType,
      auctionType: tenderType === "CLOSED" ? "CLOSED" : "OPEN",
      capacityId: capId,
      tenderStartDateTime: `${formatDateElement(
        tenderStartDate,
      )} ${tenderStartTime}`,
      tenderCloseDateTime: `${formatDateElement(
        tenderEndDate,
      )} ${convertEndTimeFormat(tenderEndTime)}`,
      bidStartDateTime: `${formatDateElement(
        biddingStartDate,
      )} ${biddingStartTime}`,
      bidCloseDateTime: `${formatDateElement(
        biddingEndDate,
      )} ${convertEndTimeFormat(biddingEndTime)}`,

      bidQuantityIncrement: 0,
      bidPriceIncrement: 0,
      bidPriceDecrement: 0,
      emdPerMw: Emd,
      ipoDateTime: `${formatDateElement(biddingEndDate)} ${convertEndTimeFormat(biddingEndTime)}`,
      paymentSecurityDays: paymentSecurity,
      initialMarginPercent: initialMargin,
      tenderDoc: generalTC,
      comments: comment,
    };

    let res = await createAuctionTender(tenderPayload);
    if (res?.data?.code === 200) {
      setLoading(false);

      if (tenderType === "CLOSED") {
        handleUserSelection(res?.data?.data?.id);
      } else {
        dispatch(auctionGet());
        dispatch(activeType2Loading(false));
        handleShowSuccessModal();
      }
    }
    dispatch(activeType2Loading(false));
    setLoading(false);
  };

  const handleUserSelection = async (id) => {
    if (editClosed?.length > 0 || defData?.length > 0) {
      let payload = {
        participantIds:
          editClosed?.length > 0 && type === "edit" ? editClosed : defData,
      };
      let res = await handleInviteParticipants(id, payload);
      if (res?.data?.code === 200) {
        dispatch(auctionGet());
        dispatch(activeType2Loading(false));
        type === "edit" ? handleClose() : handleShowSuccessModal();
      } else {
        setLoading(false);
        dispatch(activeType2Loading(false));
      }
    } else {
      dispatch(auctionGet());
      dispatch(activeType2Loading(false));
      type === "edit" ? handleClose() : handleShowSuccessModal();
    }
  };

  const updateTender = async () => {
    let tenderPayload = {
      tenderEntityName: entityName?.entityName,
      tenderStartDateTime: `${formatDateElement(
        tenderStartDate,
      )} ${tenderStartTime}`,
      tenderCloseDateTime: `${formatDateElement(
        tenderEndDate,
      )} ${convertEndTimeFormat(tenderEndTime)}`,
      bidStartDateTime: `${formatDateElement(
        biddingStartDate,
      )} ${biddingStartTime}`,
      bidCloseDateTime: `${formatDateElement(
        biddingEndDate,
      )} ${convertEndTimeFormat(biddingEndTime)}`,

      emdPerMw: Emd,
      ipoDateTime: `${formatDateElement(biddingEndDate)} ${convertEndTimeFormat(biddingEndTime)}`,
      auctionType: tenderType === "CLOSED" ? "CLOSED" : "OPEN",
      tenderDoc: generalTC,
    };

    let res = await updateAuctionTender(tenderPayload, tenderData?.id);
    if (res?.data?.code === 200) {
      if (tenderType === "CLOSED") {
        if (type === "edit") {
          if (editClosed?.length > 0) {
            await handleUserSelection(res?.data?.data?.id);
          } else {
            dispatch(auctionGet());
            dispatch(activeType2Loading(false));
            handleClose();
          }
        } else {
          await handleUserSelection(res?.data?.data?.id);
        }
      } else {
        dispatch(auctionGet());
        dispatch(activeType2Loading(false));
        handleClose();
      }
    }
  };

  // Helper to add days to a date
  const addDays = (date, days) => {
    if (!date) return "";
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  const handleTerminate = async () => {
    dispatch(activeType2Loading(true));
    let res = await terminateTender({}, tenderData?.id);
    if (res?.data?.code === 200) {
      handleClose();
      dispatch(activeType2Loading(false));
    } else {
      dispatch(activeType2Loading(false));
      ErrorMessage(res?.data?.message);
    }
  };

  const handleActivateModal = () => {
    setConfirmText(`Do you want to Terminate this tender?`);
    setConfirmHeader("Terminate Tender");
    setConfirmAction("terminate");
    setConfirmModal(true);
  };

  const handleShowSuccessModal = () => {
    setHideForm(true);
    setConfirmText(
      <>
        RFP/RFQ submitted successfully. Please click{" "}
        <strong>`Activate Tender`</strong> to notify sellers and enable further
        actions.
      </>,
    );
    setConfirmHeader("Activate RFP/RFQ");
    setConfirmAction("success");
    setConfirmModal(true);
  };

  const handleConfirmModalSubmit = () => {
    setConfirmModal(false);
    if (confirmAction === "terminate") {
      handleTerminate();
    } else if (confirmAction === "success") {
      setHideForm(false);
      onSuccess?.();
      handleClose();
    }
    setConfirmAction(null);
  };

  const isTenderStartToday =
    new Date(tenderStartDate).toDateString() === new Date().toDateString();
  const _now = new Date();
  const _minTotalMins = _now.getHours() * 60 + _now.getMinutes();
  const _roundedMins = Math.ceil(_minTotalMins / 15) * 15;
  // Odisha: next 15-min slot after now+2hrs; non-Odisha: next 15-min slot from now
  const _odishaOpenRounded = Math.ceil((_minTotalMins + 120) / 15) * 15;
  const openingTimeStartHours = isTenderStartToday
    ? Math.min(
        Math.floor((isOdisha ? _odishaOpenRounded : _roundedMins) / 60),
        24,
      )
    : 0;
  const openingTimeStartMinutes = isTenderStartToday
    ? (isOdisha ? _odishaOpenRounded : _roundedMins) % 60
    : 0;

  // Closing date/time: Odisha min 48 hrs, non-Odisha min 2 hrs after tender start
  const _tStartH = Number(tenderStartTime?.split(":")?.[0] ?? 0);
  const _tStartM = Number(tenderStartTime?.split(":")?.[1] ?? 0);
  const _closingOffsetMins = isOdisha ? 2880 : 120;
  const _closingMinTotalMins = _tStartH * 60 + _tStartM + _closingOffsetMins;
  const closingMinDate = tenderStartDate
    ? addDays(
        new Date(tenderStartDate),
        Math.floor(_closingMinTotalMins / 1440),
      )
    : null;
  const _isClosingOnMinDay = checkAreSame(tenderEndDate, closingMinDate);
  const closingTimeStartHours = _isClosingOnMinDay
    ? Math.floor((_closingMinTotalMins % 1440) / 60)
    : 0;
  const closingTimeStartMinutes = _isClosingOnMinDay
    ? _closingMinTotalMins % 60
    : 0;

  // Bidding end date/time: Odisha min 2 hrs, non-Odisha min 1 hr after bidding start
  const _bStartH = Number(biddingStartTime?.split(":")?.[0] ?? 0);
  const _bStartM = Number(biddingStartTime?.split(":")?.[1] ?? 0);
  const _bEndOffsetMins = isOdisha ? 120 : 60;
  const _bEndMinTotalMins = _bStartH * 60 + _bStartM + _bEndOffsetMins;
  const biddingEndMinDate = biddingStartDate
    ? addDays(
        new Date(biddingStartDate),
        Math.floor(_bEndMinTotalMins / 1440),
      )
    : null;
  const _isBidEndOnMinDay = checkAreSame(biddingEndDate, biddingEndMinDate);
  const biddingEndTimeStartHours = _isBidEndOnMinDay
    ? Math.floor((_bEndMinTotalMins % 1440) / 60)
    : 0;
  const biddingEndTimeStartMinutes = _isBidEndOnMinDay
    ? _bEndMinTotalMins % 60
    : 0;

  return (
    <>
      <PdfPreviewModal />
      <ConfirmationModal
        open={confirmModal}
        handleClose={() => {
          setConfirmModal(false);
          setConfirmAction(null);
        }}
        data={confirmText}
        header={confirmHeader}
        handleSubmit={handleConfirmModalSubmit}
        viewOk={confirmAction === "success"}
      />
      <Modal
        open={open && !hideForm}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <>
          <div className={`popupModal ${Styles.tenderModal}`}>
            <div
              className={`display_flex_row modalHeading ${Styles.modalHeading}`}
            >
              <div className="headingText">
                {type === "create"
                  ? "Create"
                  : duplicate
                    ? "Duplicate"
                    : "Edit"}{" "}
                Tender
              </div>
              <Close
                style={{
                  fontSize: "24px",
                  color: "#777777",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              />
            </div>
            <div className={`scroll_bar_y ${Styles.tenderInputContianer}`}>
              <div className={`display_flex_row ${Styles.excel_upload_main}`}>
                {state === "OD" ? (
                  <div className={Styles.tenderInputsSelections}>
                    <div className={Styles.interIntraSelection}>
                      {tenderType === "CLOSED" ? (
                        <div
                          className={
                            tenderType === "CLOSED" && Styles.activeTenderType
                          }
                          onClick={() => handleTenderType("CLOSED")}
                        >
                          Intrastate
                        </div>
                      ) : (
                        <div
                          className={
                            tenderType === "OPEN" && Styles.activeTenderType
                          }
                          onClick={() => handleTenderType("OPEN")}
                        >
                          Interstate
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className={Styles.tenderInputsSelections}>
                    <div className={Styles.interIntraSelection}>
                      <div
                        className={
                          tenderType === "OPEN" && Styles.activeTenderType
                        }
                        onClick={() => handleTenderType("OPEN")}
                      >
                        Interstate
                      </div>
                      <div
                        className={
                          tenderType === "CLOSED" && Styles.activeTenderType
                        }
                        onClick={() => handleTenderType("CLOSED")}
                      >
                        Intrastate
                      </div>
                    </div>
                  </div>
                )}
                <div className={Styles.tenderUploadSection}>
                  {traderParent && (
                    <div>
                      <SelectInput
                        list={traderUserList}
                        onChange={handleTraderUserSelection}
                        example={"Select Entity"}
                        value={entityName}
                        height={35}
                      />
                      {error?.entityName && (
                        <div className={Styles.error}>{error.entityName}</div>
                      )}
                    </div>
                  )}
                  <div
                    className={Styles.fileUploadTemplate}
                    style={{ cursor: "pointer" }}
                  >
                    <Fileupload
                      key={excelResetKey}
                      accept={".xlsx"}
                      value={excelUpload}
                      onChange={(sheetData, fileName) =>
                        handleExcelUploadRFQ(sheetData, fileName)
                      }
                      example={"Upload Template"}
                      fileType={"excel"}
                      id={"excel-upload"}
                      viewType={2}
                      height={35}
                    />
                  </div>
                  <div
                    onClick={() => handleDownloadExcel()}
                    className={Styles.excel_down_button}
                  >
                    <img src={FileDownloadIcon} alt="" />
                    <span style={{ textWrap: "nowrap" }}>Template</span>
                  </div>
                </div>
              </div>

              <div className={`display_flex_row ${Styles.tendersection}`}>
                <div
                  className={`display_flex_row_center ${Styles.sectionHeading}`}
                >
                  Tender (IPO)
                </div>

                {/* Start Date */}
                <div>
                  <AuctionDateInput
                    heading={"Opening Date"}
                    value={tenderStartDate}
                    onChange={(value) => handleTenderStartDate(value)}
                    minDate={
                      // If current time is 10 PM (22:00) or later, start date must be tomorrow
                      new Date().getHours() >= 22
                        ? addDays(new Date(), 1)
                        : new Date()
                    }
                    error={error?.tenderStartDate}
                  />
                </div>

                {/* Start Time */}
                <div>
                  <AuctionTimeInput
                    type={"startTime"}
                    heading={"Opening Time"}
                    value={tenderStartTime}
                    onChange={(value) => handleTenderStartTime(value)}
                    startDate={tenderStartDate}
                    error={error?.tenderStartTime}
                    minHr={0}
                    startHours={openingTimeStartHours}
                    startMinutes={openingTimeStartMinutes}
                  />
                </div>

                {/* End Date */}
                <div>
                  <AuctionDateInput
                    heading={"Closing Date"}
                    value={tenderEndDate}
                    onChange={(value) => handleTenderEndDate(value)}
                    minDate={closingMinDate}
                    error={error?.tenderEndDate}
                  />
                </div>

                {/* End Time */}
                <div>
                  <AuctionTimeInput
                    type={"endTime"}
                    heading={"Closing Time"}
                    value={tenderEndTime === "23:59" ? "24:00" : tenderEndTime}
                    onChange={(value) =>
                      handleTenderEndTime(value === "24:00" ? "23:59" : value)
                    }
                    startDate={tenderEndDate}
                    startHours={closingTimeStartHours}
                    startMinutes={closingTimeStartMinutes}
                    error={error?.tenderEndTime}
                  />
                </div>
              </div>
              <div className={`display_flex_row ${Styles.tendersection}`}>
                <div
                  className={`display_flex_row_center ${Styles.sectionHeading}`}
                >
                  Bidding
                </div>
                <div>
                  <AuctionDateInput
                    heading={"Start Date"}
                    value={biddingStartDate}
                    onChange={(value) => handleBiddingStartDate(value)}
                    minDate={
                      Number(tenderStartTime?.split(":")?.[0]) === 23 &&
                      Number(tenderStartTime?.split(":")?.[1]) >= 45
                        ? addDays(tenderStartDate, 1)
                        : tenderStartDate
                    }
                    height={35}
                    error={error?.biddingStartDate}
                    maxDate={tenderEndDate}
                    disabled={!(tenderStartDate && tenderEndDate)}
                  />
                </div>
                <div>
                  <AuctionTimeInput
                    type={"startTime"}
                    heading={"Start Time"}
                    value={biddingStartTime}
                    onChange={(value) => handleBiddingStartTime(value)}
                    startDate={biddingStartDate}
                    startHours={
                      checkAreSame(biddingStartDate, tenderStartDate)
                        ? Math.floor(
                            (Math.ceil(
                              (Number(tenderStartTime?.split(":")?.[0] ?? 0) *
                                60 +
                                Number(tenderStartTime?.split(":")?.[1] ?? 0) +
                                (isOdisha ? 60 : 0)) /
                                15,
                            ) *
                              15) /
                              60,
                          )
                        : 0
                    }
                    startMinutes={
                      checkAreSame(biddingStartDate, tenderStartDate)
                        ? (Math.ceil(
                            (Number(tenderStartTime?.split(":")?.[0] ?? 0) *
                              60 +
                              Number(tenderStartTime?.split(":")?.[1] ?? 0) +
                              (isOdisha ? 60 : 0)) /
                              15,
                          ) *
                            15) %
                          60
                        : 0
                    }
                    error={error?.biddingStartTime}
                  />
                </div>
                <div>
                  <AuctionDateInput
                    heading={"End Date"}
                    value={biddingEndDate}
                    onChange={(value) => handleBiddingEndDate(value)}
                    error={error?.biddingEndDate}
                    minDate={biddingEndMinDate}
                    maxDate={tenderEndDate}
                    disabled={
                      !(tenderStartDate && tenderEndDate && biddingStartDate)
                    }
                  />
                </div>
                <div>
                  <AuctionTimeInput
                    type={"endTime"}
                    heading={"End Time"}
                    value={
                      biddingEndTime === "23:59" ? "24:00" : biddingEndTime
                    }
                    onChange={(value) =>
                      handleBiddingEndTime(value === "24:00" ? "23:59" : value)
                    }
                    startDate={biddingEndDate}
                    error={error?.biddingEndTime}
                    startHours={biddingEndTimeStartHours}
                    startMinutes={biddingEndTimeStartMinutes}
                  />
                </div>
              </div>
              <div
                className={`display_flex_row_gap_8_only ${Styles.noteContainer}`}
              >
                <b>Note:</b>
                <span>
                  The Requisition Start Date/Time must be at least 48 hours
                  after the Tender End Date/Time.
                </span>
              </div>

              {requisitions?.map((ele, index) => {
                let isRtc =
                  ele?.startTime === "00:00" &&
                  (ele?.endTime === "23:59" || ele?.endTime === "24:00");
                return (
                  <div
                    className={`display_flex_row ${Styles.tenderRequisitions}`}
                    key={index}
                  >
                    <div
                      className={`display_flex_row_center ${Styles.sectionHeading}`}
                    >
                      Requisition {index + 1}
                    </div>
                    <div>
                      <DateInput
                        heading={"Start Date"}
                        value={requisitions[index]?.startDate}
                        onChange={(value) =>
                          handleRequirementChange(index, "startDate", value)
                        }
                        minDate={
                          Number(tenderEndTime?.split(":")?.[0]) >= 22
                            ? addDays(tenderEndDate, 3)
                            : addDays(tenderEndDate, 3)
                        }
                        height={35}
                        error={error[`startDate_${index}`]}
                        disabled={!(tenderStartDate && tenderEndDate)}
                      />
                    </div>
                    <div>
                      <DateInput
                        heading={"End Date"}
                        value={requisitions[index]?.endDate}
                        onChange={(value) =>
                          handleRequirementChange(index, "endDate", value)
                        }
                        minDate={requisitions[index]?.startDate}
                        height={35}
                        error={error[`endDate_${index}`]}
                        disabled={
                          !(
                            tenderStartDate &&
                            tenderEndDate &&
                            requisitions[index]?.startDate
                          )
                        }
                      />
                    </div>
                    <div>
                      <TimeInput
                        type={"startTime"}
                        heading={"Start Time"}
                        value={requisitions[index]?.startTime}
                        onChange={(value) =>
                          handleRequirementChange(index, "startTime", value)
                        }
                        startDate={requisitions[index]?.startDate}
                        minutesStep={15}
                        height={35}
                        error={error[`startTime_${index}`]}
                        noTooltip={true}
                        rtcButton={true}
                        endTime={requisitions[index]?.endTime}
                        handleRTC={(value) => {
                          if (value === "24:00") {
                            setRequisitions((prev) =>
                              prev.map((req, i) =>
                                i === index
                                  ? {
                                      ...req,
                                      startTime: "00:00",
                                      endTime: "24:00",
                                    }
                                  : req,
                              ),
                            );
                          } else {
                            setRequisitions((prev) =>
                              prev.map((req, i) =>
                                i === index
                                  ? { ...req, startTime: "", endTime: value }
                                  : req,
                              ),
                            );
                          }
                        }}
                        startTime={
                          formatDateElement(tenderEndDate) ===
                            formatDateElement(requisitions[index]?.startDate) &&
                          tenderEndTime
                        }
                        minHr={4}
                        isRtc={isRtc}
                        disabled={isRtc}
                      />
                    </div>
                    <div>
                      <TimeInput
                        type={"endTime"}
                        heading={"End Time"}
                        value={
                          requisitions[index]?.endTime === "23:59"
                            ? "24:00"
                            : requisitions[index]?.endTime
                        }
                        onChange={(value) =>
                          handleRequirementChange(
                            index,
                            "endTime",
                            value === "24:00" ? "23:59" : value,
                          )
                        }
                        startDate={requisitions[index]?.endDate}
                        minutesStep={15}
                        height={35}
                        error={error[`endTime_${index}`]}
                        startTime={requisitions[index]?.startTime}
                        isRtc={isRtc}
                        disabled={isRtc}
                      />
                    </div>
                    <div>
                      <TextInput
                        heading={"Req. Quantity (MW)"}
                        value={requisitions[index]?.quantity}
                        onChange={(value) => {
                          // Reject negative values
                          if (Number(value) < 0) {
                            toast.error(
                              "Quantity cannot be negative",
                              toastProperties,
                            );
                            return;
                          }

                          if (
                            requisitions[index]?.minQty &&
                            Number(value) < Number(requisitions[index]?.minQty)
                          ) {
                            toast.error(
                              "Quantity should be greater than Minimum Quantity",
                              toastProperties,
                            );
                          } else {
                            handleRequirementChange(index, "quantity", value);
                          }
                        }}
                        type={"number"}
                        allowDecimal={true}
                        allowNegative={false}
                        step="0.001"
                        example={"Eg. 60.123"}
                        height={35}
                        error={error[`quantity_${index}`]}
                      />
                    </div>
                    <div>
                      <TextInput
                        heading={"Min. Quantity (MW)"}
                        value={requisitions[index]?.minQty}
                        onChange={(value) => {
                          // Reject negative values
                          if (Number(value) < 0) {
                            toast.error(
                              "Minimum Quantity cannot be negative",
                              toastProperties,
                            );
                            return;
                          }

                          if (
                            Number(value) >
                            Number(requisitions[index]?.quantity)
                          ) {
                            toast.error(
                              "Minimum Quantity should be less than Required Quantity",
                              toastProperties,
                            );
                          } else {
                            handleRequirementChange(index, "minQty", value);
                          }
                        }}
                        type={"number"}
                        allowDecimal={true}
                        allowNegative={false}
                        step="0.001"
                        example={"Eg. 60.123"}
                        height={35}
                        error={error[`minQty_${index}`]}
                      />
                    </div>
                    <div
                      className={`display_flex_column_gap_8 ${Styles.alterButtons}`}
                    >
                      <div
                        className={Styles.deleteButton}
                        onClick={() => handleRemoveRequirement(index)}
                        style={{
                          cursor: `${
                            requisitions?.length < 1 ? "no-drop" : "cursor"
                          }`,
                        }}
                      >
                        <DeleteIcon
                          style={{ fontSize: "14px", color: "#8C8A96" }}
                        />
                      </div>
                      <div
                        onClick={() => handleAddRequirement()}
                        className={Styles.addButton}
                      >
                        <AddIcon
                          style={{ fontSize: "14px", color: "#F1935C" }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}

              <div
                className={`${"display_flex_row"} ${Styles.tenderSelection}`}
              >
                <div>
                  <Fileupload
                    accept={".pdf"}
                    id={"general-terms-conditions"}
                    value={generalTC}
                    onChange={handleGeneralTC}
                    height={"35"}
                    heading={"Upload General T&C"}
                    example={"Upload T&C (.pdf)"}
                    fileType={"pdf"}
                  />
                </div>
                <div>
                  <TextInput
                    heading={"Comment"}
                    value={comment}
                    onChange={(value) => handleComment(value)}
                    type={"text"}
                    example={"Eg. Comment"}
                    height={35}
                  />
                </div>
              </div>
              {!tenderData?.id && (
                <div className={Styles.level6Continaer}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",

                      fontSize: "12px",
                      color: "#8C8A96",
                      fontWeight: 400,
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{ marginRight: "8px" }}
                      checked={acceptSystemTerms}
                      onChange={(e) => setAcceptSystemTerms(e.target.checked)}
                    />
                    I Understand and Accept&nbsp;
                    <span
                      onClick={() => {
                        handlePreviewGeneralTerms(
                          "https://gna-general-files.s3.ap-south-1.amazonaws.com/Website+Assets+PDF/GNA-bye-laws.pdf",
                          {
                            hideHeader: true,
                          },
                        );
                      }}
                      type="button"
                      style={{
                        color: "#ff9800",
                        cursor: "pointer",
                      }}
                    >
                      System Terms and Conditions
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className={`display_flex_row_gap_8 ${Styles.buttonContainer}`}>
              <div className={`activeButton_type_3`} onClick={handleClose}>
                Cancel
              </div>
              {type === "edit" && !duplicate && (
                <div className="delete_button" onClick={handleActivateModal}>
                  Terminate
                </div>
              )}
              {loading ? (
                <div className={`activeButton`} style={{ width: "100px" }}>
                  <CircularProgress size={"20px"} />
                </div>
              ) : (
                <div
                  className={`activeButton`}
                  // Only allow the click if NOT currently submitting
                  onClick={() => {
                    handleFormSubmit();
                  }}
                  style={{
                    width: "100px",
                    // Optional: Add visual cues that it is disabled
                    opacity: isSubmitting ? 0.6 : 1,
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                  }}
                >
                  {/* Optional: Change text while processing */}
                  {isSubmitting
                    ? "Wait..."
                    : type === "edit" && !duplicate
                      ? "Update"
                      : "Submit"}
                </div>
              )}
            </div>
          </div>
        </>
      </Modal>
    </>
  );
};

export default CreateRfpTender;
